import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const AccOtherSourcesIncome: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      {values?.IncomeOthSrc ? (
        <>
          <Accordion.Item eventKey="income-source-5">
            <ContextAwareToggle eventKey="income-source-5" isChild={true}>
              <div className="btn-content justify-content-between">
                <p className="leading-para fw-bold mb-0">Other Sources</p>
                <p className="leading-para fw-bold mb-0">
                  <PriceDisplay price={values?.IncomeOthSrc || 0} />
                </p>
              </div>
            </ContextAwareToggle>
            <Accordion.Body>
              <section>
                <dl className="eds-list eds-dl eds-inline-between">
                  <RenderOtherSourcesListItem
                    title="Interest Income"
                    income={values?.OthersInc?.TotalInterestIncome || 0}
                  />

                  <RenderOtherSourcesListItem
                    title="Dividend Income"
                    income={values?.OthersInc?.TotalDividendIncome || 0}
                  />

                  <RenderOtherSourcesListItem
                    title="Agricultural Income"
                    income={values?.OthersInc?.TotalAgriculturalIncome || 0}
                  />

                  <RenderOtherSourcesListItem
                    title="Exempt Income"
                    income={values?.OthersInc?.TotalExemptIncome || 0}
                  />

                  <RenderOtherSourcesListItem
                    title="Other Income"
                    income={values?.OthersInc?.TotalOtherIncome || 0}
                  />

                  <div className="eds-list--item eds-list--item-subtotal">
                    <dt>Total:</dt>
                    <dd>
                      <PriceDisplay price={values?.IncomeOthSrc || 0} />
                    </dd>
                  </div>
                </dl>
              </section>
            </Accordion.Body>
          </Accordion.Item>
        </>
      ) : null}
    </>
  );
};

export default AccOtherSourcesIncome;

const RenderOtherSourcesListItem = ({ income, title }: { income: number; title: string }) => {
  return (
    <>
      {income ? (
        <div className="eds-list--item">
          <dt>{title}</dt>
          <dd>
            <PriceDisplay price={income} />
          </dd>
        </div>
      ) : null}
    </>
  );
};
